import { SelectionState, EditorState } from "draft-js";
import { insertBlock, removeBlock, setSelectionToBlock } from "lib/helpers";
import Debug from 'debug';

const debug = Debug('table-block');

/**
 * @param {Draft.ContentBlock} block
 * @param {DraftEditorStore} store
 * @param {DraftEditorPluginAPI} pluginAPI
 * @param {Object} tableBlockMap
 */
export function createTableBlockProps(block, store, pluginAPI, tableBlockMap) {
	const { getEditorState, setEditorState } = store;
	const {
		takeOverStore,
		recoverStore,
		readMemory,
		updateMemory,
		triggerCommand,
		focusHostEditor,
		refreshToolbar
	} = pluginAPI;

	const getTableBlockForKey = key => tableBlockMap[key];

	// 进入表格编辑模式
	const enter = (key) => {
		debug('enter ' + key);
		if (store.getEditorEnviorment() === 'root') {
			setSelectionToBlock(store, block, 'collapse');
		}
		takeOverStore(({ focusTableKey }) => {
			return tableBlockMap[key].getActiveCellStore();
		});
		updateMemory(memory => ({
			...memory,
			focusTableKey: key,
		}));
	}

	// 退出表格编辑模式
	const exit = async () => {
		const current = readMemory(memory => memory.focusTableKey);
		if (!current) {
			return false;
		}
		debug('exit ' + current);
		recoverStore();
		updateMemory(memory => ({
			...memory,
			focusTableKey: null,
		}));
		// await new Promise(requestAnimationFrame);
		return true;
	};

	// 处理表格内输入回车
	const handleReturn = position => async () => {
		focusHostEditor();
		const editorState = getEditorState();
		setEditorState(insertBlock(editorState, block.getKey(), position));
	};

	// 处理表格内的焦点转移
	const handleFocus = position => async () => {
		const editorState = getEditorState();
		const nextBlock = position === 'below' ?
			editorState.getCurrentContent().getBlockAfter(block.getKey()) :
			editorState.getCurrentContent().getBlockBefore(block.getKey());

		if (nextBlock) {
			if (nextBlock.getType().toLowerCase() === 'table') {
				const key = nextBlock.getKey();
				const blockComponent = getTableBlockForKey(key);
				if (blockComponent) {
					position === 'below' ? blockComponent.focusFirstRow(): blockComponent.focusLastRow();
				}
			}
			else {
				setTimeout(() => setSelectionToBlock(store, nextBlock, 'expand'), 1);
			}
		}
		else {
			focusHostEditor();
			requestAnimationFrame(() => {
				setEditorState(insertBlock(editorState, block.getKey(), position === 'below' ? 'after' : 'before'));
			});
		}
	}

	const blockKey = block.getKey();
	return {
		store,
		data: block.getData(),
		onRef: tableBlock => {
			if (tableBlock) {
				tableBlockMap[blockKey] = tableBlock;
			}
			else {
				delete tableBlockMap[blockKey];
			}
		},
		onFocusTable: () => enter(blockKey),
		onExitTable: async (evt) => {
			if (await exit()) {
				focusHostEditor();
			}
		},
		onSave: () => triggerCommand('save'),
		onReturnStart: handleReturn('before'),
		onReturnEnd: handleReturn('after'),
		onFocusBelow: handleFocus('below'),
		onFocusAbove: handleFocus('above'),
		onFocusCell: (key) => updateMemory(memory => ({
			...memory,
			focusTableKey: blockKey,
			focusTableCellKey: key
		})),
		onSelectionChange: () => {
			refreshToolbar();
		},
		onRemoveTable: () => removeBlock(store, block, 'forward'),
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/tablePlugin/createTableBlockProps.js